import React from 'react'
import { Form, Radio } from 'antd'

function ArapTypeSelect(props) {
    let options = []
    if(props.documentType === 'income'){
        options = [
            { value: '现收', label: '现收' },
            { value: '应收', label: '应收' },
            { value: '核销应收', label: '核销应收' },
        ]
    } else if(props.documentType === 'cost'){
        options = [
            { value: '现付', label: '现付' },
            { value: '应付', label: '应付' },
            { value: '核销应付', label: '核销应付' },
        ]
    }else if(props.documentType === 'expense'){
        options = [
            { value: '现付', label: '现付' },
            { value: '应付', label: '应付' },
        ]
    }
    return (
        <Form.Item
            label={props.label}
            required={props.required}
            style={props.style}
            wrapperCol={props.wrapperCol}
            name={props.name}
        >
            <Radio.Group 
                onChange={(e) => {
                props.onChange(e.target.value)
               }}
            >
               {options.map((item) => (
                <Radio value={item.value} key={item.value} disabled={props.disabled === item.value}>{item.label}</Radio>
               ))}
            </Radio.Group>
        </Form.Item>
    )
}

export default ArapTypeSelect